import * as constants from "./constants";


const initialState = {
  allDocumentField: [],
  fetchingLoading: true,
  updateLoading: false,
  totalRecords: 0,
  isAdding: false,
};

const documentFieldReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.FETCH_DOCUMENT_FIELDS:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.FETCH_DOCUMENT_FIELDS_SUCCESS:
      return {
        ...state,
        fetchingLoading: false,
        isAdding: false,
        allDocumentField: action.data,
      };
    case constants.FETCH_DOCUMENT_FIELDS_ERROR:
      return {
        ...state,
        fetchingLoading: false,
        isAdding: false,
      };
    case constants.UPDATE_DOCUMENT_FIELDS:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.UPDATE_DOCUMENT_FIELDS_SUCCESS:
      const updated = state.allDocumentField.map((el) =>
        el.id === action.data.id ? { ...el, ...action.data } : el
      );
      return {
        ...state,
        allDocumentField: updated,
        updateLoading: false,
        isAdding: false,
      };
    case constants.UPDATE_DOCUMENT_FIELDS_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };
    case constants.IS_ADDING_UPDATE:
      return {
        ...state,
        isAdding: action.data,
      };

    default:
      return state;
  }
};

export default documentFieldReducer;
